import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [activeItem, setActiveItem] = useState("");

  useEffect(() => {
    const path = window.location.pathname.split("/").pop();
    setActiveItem(path || "dashboard");
  }, []);

  return (
    <div className="footer-container">
      <Link to="/profile" className={`menu-item ${activeItem === "profile" ? "active" : ""}`}>
        {/* <img src={require("../assets/images/icons/menu/profile-footer.png")} alt="Profile" /> */}
         <i className="fa fa-user-circle footer-icon"></i>
        <span>Profile</span>
      </Link>

      {localStorage.getItem("Role") === "9" ? (
        <Link to="/sharelocation" className={`menu-item ${activeItem === "sharelocation" ? "active" : ""}`}>
          <i className="fa fa-location-dot footer-icon"></i>
          <span>Share Location</span>
        </Link>
      ) : (
        <Link to="/homework" className={`menu-item ${activeItem === "homework" ? "active" : ""}`}>
          <i className="fa fa-list-alt footer-icon"></i>
          <span>Homework</span>
        </Link>
      )}

      <Link to="/dashboard" className={`menu-item center ${activeItem === "tracking-dashboard" ? "active-center" : ""}`}>
        <div className="center-icon">
          <img src={require("../assets/images/icons/menu/home.png")} alt="Dashboard" />
        </div>
      </Link>

      <Link to="/myattendance" className={`menu-item ${activeItem === "myattendance" ? "active" : ""}`}>
        <i className="fa fa-book footer-icon"></i>
        <span>Attendance</span>
      </Link>

      <Link to="/more" className={`menu-item ${activeItem === "more" ? "active" : ""}`}>
         <i className="fa fa-bars footer-icon"></i>
        <span>More</span>
      </Link>
    </div>
  );
};

export default Footer;
